"use client";

import dynamic from "next/dynamic";
import { ParagraphHeading } from "../shared/ParagraphHeading";
import type { ParagraphMaps as ParagraphMapsData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "../Paragraph.module.css";

/**
 * Layout 23 — `PARAGRAPH_MAPS_LAYOUT`: mapa Leaflet z punktami GPX.
 *
 * **Dynamic import + `ssr: false`** — Leaflet odwołuje się do `window`
 * (np. tworząc DOM Marker'a) i wybuchnie w SSR (Next.js Server Components).
 * `next/dynamic` z `ssr: false` ładuje komponent dopiero w przeglądarce.
 *
 * **Why no SSR markup:** mapa to czysta interakcja CSR — brak SEO value
 * w renderowaniu pustego diva po stronie serwera. Loading placeholder
 * pokazuje się przez chwilę przed hydration'em.
 */
const MapClient = dynamic(() => import("./ParagraphMapsClient").then((m) => m.ParagraphMapsClient), {
  ssr: false,
  loading: () => (
    <div className={styles.mapWrap}>
      <div className={styles.mapLoading}>Loading map…</div>
    </div>
  ),
});

export function ParagraphMaps({
  paragraph,
  t,
}: {
  paragraph: ParagraphMapsData;
  t: ParagraphTranslations;
}) {
  const points = paragraph.points ?? [];

  return (
    <section className={styles.paragraph}>
      <ParagraphHeading name={paragraph.name} centerHeader={paragraph.center_header} />
      {points.length === 0 ? (
        <div className={styles.empty}>{t.map.empty}</div>
      ) : (
        <MapClient points={points} t={t} />
      )}
    </section>
  );
}
